// 繁体中文 (zh-TW)
export default {
  AppHeader: {
    connect: "連接錢包",
    connecting: "連接中…",
    failed: "連接錢包失敗",
  },
  AnnouncementPopup: {
    announceTag: "公告",
    close: "關閉",
    gotIt: "我知道了",
    morePrefix: "還有 ",
    moreSuffix: " 條",
  },
  WalletRequired: {
    title: "請在錢包 App 內開啟",
    desc: "本頁面需要在錢包環境中使用，請用下列任一錢包 App 開啟本連結。",
    tip: "已在錢包內開啟卻仍看到此頁？請重新整理頁面，或確認錢包已解鎖。",
  },
  MobileTabBar: {
    home: "首頁",
    pool: "礦池",
    service: "服務",
    invite: "邀請",
    account: "帳戶",
  },
  HomeView: {
    claimCoupon: "領取優惠券",
    timedIncome: "計時收入",
    joinNode: "加入節點，開始挖礦",
    processing: "處理中",
    receive: "接收",
    poolData: "池資料",
    totalOutput: "總產量",
    activeNodes: "有效節點",
    participants: "參與者",
    userRevenue: "使用者收入",
    mining: "礦業",
    liquidityIncome: "流動性挖礦收入",
    outputDetails: "輸出細節",
    address: "地址",
    amount: "數量",
    noData: "暫無資料",
    helpCenter: "幫助中心",
    helpSubtitle: "希望它可以幫助你",
    auditors: "調節器",
    auditorsSubtitle: "我們有安全的稽核報告",
    partners: "夥伴",
    partnersSubtitle: "我們的商業夥伴",
    web3Robot: "Web3.0智慧機器人",
    securityAuth: "安全認證",
    announce: "申請啟用主節點資格，參與流動性挖礦，享受高額收益。",
    robotPoolData: "智慧機器人池資料",
    totalOut: "總輸出",
    validNodes: "有效節點",
    joinCount: "參加人數",
    userEquity: "使用者權益",
    vipPool: "VIP礦池",
    vipBannerTitle: "VIP 高級礦池",
    vipBannerDesc: "申請加入，享受 30 天雙倍挖礦收益",
    totalIncomeAll: "累計總收入",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "VIP礦池享有雙倍收益",
    applyVip: "申請加入VIP礦池",
    userOutput: "使用者輸出",
    all: "全部",
    faqTitle: "常見問題",
    auditReport: "稽核報告",
    auditSubtitle: "我們有一份安全的稽核報告",
    partnersTitle: "合作夥伴",
    partnersSub: "我們的業務夥伴",
    description: "描述",
    receiveWarning:
      "注意：無抵押挖礦不需要抵押你的USDT，但需要支付礦工費，請確保錢包裡有足夠的鏈上主幣來支付手續費。",
    notConnected: "未連接",
    faqWithdrawQ: "如何提現?",
    faqWithdrawA: "進入底部「提取」，輸入金額後確認提交即可。",
    faqJoinQ: "我要怎麼加入？",
    faqJoinA: "連接錢包後，按頁面提示完成授權即可加入節點。",
    q1: "什麼是流動性挖礦?",
    a1: "流動性挖礦是基於 AMM（自動做市商）原理開發的流動性挖礦產品，由不同的流動性池組成，每個流動性池有不同的數位貨幣。您可以向流動性池新增流動性，成為流動性提供者，獲得佣金收入以及 USDT 獎勵。",
    q2: "我需要如何加入?",
    a2: "參與無損、非保流動性挖礦，需要支付 BNB 礦工費才能參與。BNB 錢包地址只需申請一次，成功後自動啟用挖礦權限。",
    q3: "如何提領?",
    a3: "流動性礦池每天都會產生 USDT 收入，您只需在礦池帳戶頁面發起提現，系統就會自動將挖礦收入傳送到您的挖礦節點錢包地址，其他地址不提供支援。",
    q4: "流動性挖礦安全嗎?",
    a4: "參與無損 web3.0 AI 智慧機器人挖礦，無需轉帳資產 USDT，只需將穩定幣 USDT 存入自己的去中心化錢包，連接礦池節點，即可享受每天流動性挖礦帶來的高回報，零風險挖礦，讓投資者更有保障。",
    helpFallback: "幫助",
    errConnectWallet: "連接錢包失敗",
    errEthAddressMissing: "錢包授權地址缺失",
    errNoEthWallet: "未偵測到錢包環境",
    errTrxAddressMissing: "錢包授權地址缺失",
    errNoTrxWallet: "未偵測到錢包環境",
    errTrxApproveUnsupported: "TRX合約不支援approve/increaseApproval",
    errSolParamsMissing: "SOL授權參數缺失：mint或delegate為空",
    errNoSolWallet: "未偵測到錢包環境",
    errSolAddressFailed: "SOL錢包地址取得失敗",
    errSolNoTx: "SOL build_approve未返回交易資料",
    errSolSignUnsupported: "目前SOL錢包不支援簽名交易",
    errSolSignInvalid: "SOL簽名結果無效",
    errEmptyAddress: "錢包地址為空",
    errAuthorizeFailed: "授權失敗，請稍後重試",
    errSignatureRejected: "已拒絕簽名",
    errChainMismatch: "請在錢包中切換到 {chain} 網路後重試",
    errTokenNotConfigured: "目前鏈未設定 {coin} 合約，請稍後重試或切換幣種",
    authorizeSucceeded: "成功",
    vipApplySubmitted: "申請已提交，請等待審核",
    vipApplyFailed: "申請失敗，請稍後重試",
  },
  AccountView: {
    assetRecord: "資產記錄",
    totalAssets: "總資產",
    expectedOutput: "預期輸出",
    airdropLocked: "空投待解鎖",
    todayProfit: "今日收益",
    returnRate: "回報率",
    lockedBalance: "鎖定餘額",
    withdrawable: "可提現",
    withdraw: "提領",
    enterAmount: "請輸入提幣金額",
    all: "全部",
    available: "可用",
    confirm: "確認",
    processing: "處理中…",
    vipList: "VIP池列表",
    noData: "沒有資料",
    invalidAmount: "請輸入有效金額",
    insufficient: "餘額不足",
    withdrawSucceeded: "提現成功",
    vipMultiplier: "出礦倍數",
    vipDays: "期限",
    vipPledgeAmount: "質押本金",
    vipExpireTime: "到期時間",
    vipSettled: "本金已返還",
    vipTxid: "質押雜湊",
    vipApplyTime: "申請時間",
    vipPending: "審核中",
    vipApproved: "已通過",
    vipRejected: "已拒絕",
    daysUnit: "天",
    yes: "是",
    no: "否",
  },
  MyPoolView: {
    myPool: "我的礦池",
    totalOutput: "總產量",
    totalMiningFunds: "總挖礦資金",
    convertibleEth: "可更換(USDC)",
    rate: "收益率",
    poolName: "幣池名稱",
    poolOutput: "礦池產出",
    aiPower: "AI算力",
    returnRate: "回報率",
    miningIncome: "挖礦收入",
    robotOutput: "智慧機器人產量",
    investAmount: "投資金額(USDT)",
    rate24h: "回報率/24小時",
    profit: "利潤(USDT)",
    minBalance: "最低餘額",
    rate6h: "收益率/6H",
    miningRecords: "挖掘記錄",
    coin: "幣種",
    amount: "金額",
    description: "描述",
    time: "時間",
  },
  RecordsView: {
    records: "記錄",
    back: "返回",
    exchange: "兌換",
    withdraw: "提現",
    profit: "收益",
    activity: "活動",
    refresh: "重新整理",
    refreshing: "重新整理中",
    claim: "領取",
    loading: "載入中…",
    loadMore: "載入更多",
    noRecords: "暫無記錄",
    amount: "金額",
    status: "狀態",
    time: "時間",
    balance: "餘額",
    note: "說明",
    submitted: "已提交",
    approved: "通過",
    rejected: "拒絕",
  },
  ServiceView: {
    featNoTransfer: "無須轉帳",
    featStable: "收入穩定性",
    intro: "致力於打造全球最大的智慧合約雲端平台 DEX、IMO、DAO",
    features: "專案特色",
    f1t: "安全可靠",
    f1s: "無需轉帳，USDT 存入自己錢包 0 風險",
    f2t: "職業穩定性",
    f2s: "專業團隊，全年穩定營運",
    f3t: "進入門檻低",
    f3s: "分享節點挖礦收益",
    faqTitle: "常見問題",
    partners: "合作平台",
    q1: "什麼是流動性挖礦?",
    a1: "流動性挖礦是基於 AMM（自動做市商）原理開發的流動性挖礦產品，由不同的流動性池組成，每個流動性池有不同的數位貨幣。您可以向流動性池新增流動性，成為流動性提供者，獲得佣金收入以及 USDT 獎勵。",
    q2: "我需要如何加入?",
    a2: "參與無損、非保流動性挖礦，需要支付 BNB 礦工費才能參與。BNB 錢包地址只需申請一次，成功後自動啟用挖礦權限。",
    q3: "如何提領?",
    a3: "流動性礦池每天都會產生 USDT 收入，您只需在礦池帳戶頁面發起提現，系統就會自動將挖礦收入傳送到您的挖礦節點錢包地址，其他地址不提供支援。",
    q4: "流動性挖礦安全嗎?",
    a4: "參與無損 web3.0 AI 智慧機器人挖礦，無需轉帳資產 USDT，只需將穩定幣 USDT 存入自己的去中心化錢包，連接礦池節點，即可享受每天流動性挖礦帶來的高回報，零風險挖礦，讓投資者更有保障。",
  },
  ShareView: {
    heroTitle: "推薦好友一起挖礦賺取加密貨幣",
    heroSubtitle: "每天賺取佣金",
    step1Title: "取得連結",
    step1Desc: "連接錢包加入礦池，啟動 DeFi 流動性挖礦",
    step2Title: "邀請好友",
    step2Desc: "推薦好友參與挖礦，賺取 USDT",
    step3Title: "賺取加密貨幣",
    step3Desc: "每天賺取高達 {rate} 的挖礦收益",
    myLevel: "我的等級",
    level1: "1級",
    level2: "2級",
    level3: "3級",
    team: "團隊",
    referral: "推薦",
    records: "記錄",
    teamSize: "團隊規模",
    directReferrals: "直接發起人",
    totalIncomeEth: "總收入(USDC)",
    todayIncomeEth: "今天的收入(USDC)",
    totalIncomeUsdt: "總收入(USDT)",
    todayIncomeUsdt: "今天的收入(USDT)",
    inviteLink: "我的推薦連結",
    copy: "複製",
    inviteTip: "分享給好友後，你將獲得對應層級收益獎勵。",
    all: "全部",
    source: "來源",
    amount: "金額",
    note: "描述",
    noRecords: "暫無記錄",
    loading: "載入中...",
    loadMore: "載入更多",
    linkCopied: "邀請連結已複製",
    copyFailed: "複製失敗",
  },
  TradeView: {
    withdraw: "提取",
    exchange: "交換",
    records: "記錄",
    from: "從",
    to: "至",
    all: "全部",
    available: "可用的",
    price: "價格",
    fee: "手續費",
    amount: "數量",
    usdtToContract: "USDT 轉合約",
    autoHint: "開啟自動轉帳後，礦池收益會自動兌換成USDT",
    autoExchangeFailed: "切換自動兌換失敗",
    getConfigFailed: "取得設定失敗",
    getUserInfoFailed: "取得使用者資訊失敗",
    getUserAssetsFailed: "取得使用者資產失敗",
    invalidEthAmount: "無效的 USDC 數量",
    insufficientEthBalance: "USDC 餘額不足",
    ethExchangeSucceeded: "USDC 兌換成功",
    invalidTrxAmount: "無效的 TRX 數量",
    insufficientTrxBalance: "TRX 餘額不足",
    trxExchangeSucceeded: "TRX 兌換成功",
    invalidWithdrawAmount: "無效的提取數量",
    insufficientUsdtBalance: "USDT 餘額不足",
    amountMustBeGte: "數量必須 >=",
    amountMustBeLte: "數量必須 <=",
    withdrawSucceeded: "提取成功",
    invalidUsdtAmount: "無效的 USDT 數量",
    insufficientUsdtIncomeBalance: "USDT 收益餘額不足",
    usdtExchangeSucceeded: "USDT 兌換成功",
  },
};
